export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.9-1118.28",
  commitId: "13048d5a5cd25f64c245db0809b0cffccbd444d4",
  commitTime: "2026-09-09T11:18:28.000Z",
});
